import { render, staticRenderFns } from "./LegalTemplate.vue?vue&type=template&id=288f4a9a&"
import script from "./LegalTemplate.vue?vue&type=script&lang=js&"
export * from "./LegalTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports